import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import { toast } from 'react-toastify';
import Loading from '../../../../common/Loading';

const TimeZoneCard = () => {
    const { clinicId } = useParams();
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [timeZone, setTimeZone] = useState(null);
    const [timeZoneList, setTimeZoneList] = useState([]);

    const { register, handleSubmit, reset } = useForm();

    useEffect(() => {
        setIsLoading(true);
        clinicService
            .getTimeZone(clinicId)
            .then((res) => {
                setTimeZone(res.data);
                reset({ timezoneid: res.data.id });
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
                toast.error('Error while getting Timezone', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });

        clinicService
            .getAllTimeZones()
            .then((res) => {
                setTimeZoneList(res.data);
            })
            .catch(() => {
                toast.error('Error while getting All Timezone', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    }, [clinicId, reset]);

    const onSubmit = (data) => {
        clinicService
            .updateTimezone(clinicId, data)
            .then((res) => {
                toast.success('Updated Timezone', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                setIsEditing(false);
                setTimeZone(res.data);
            })
            .catch(() => {
                toast.error('Error while updating timezone', {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };

    return (
        <div className="notifications-panel">
            <div className="notifications-panel__header justify-content-between">
                <span className="d-flex align-items-center gap-2">
                    <i className="bi bi-globe"></i>
                    Timezone
                </span>
                <button
                    type="button"
                    className={`btn btn-sm ${isEditing ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                    onClick={() => setIsEditing(!isEditing)}
                >
                    <i className={`bi ${isEditing ? 'bi-x' : 'bi-pencil-square'}`}></i>
                    {isEditing ? ' Cancel' : ' Edit'}
                </button>
            </div>
            <div className="notifications-panel__body">
                {isLoading ? (
                    <Loading />
                ) : isEditing ? (
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="timezoneid" className="notifications-form-label">
                            Timezone
                        </label>
                        <select className="form-select form-select-sm" id="timezoneid" {...register('timezoneid')}>
                            {timeZoneList.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.timezoneName}
                                </option>
                            ))}
                        </select>
                        <div className="d-flex mt-3 pt-2 border-top">
                            <button className="btn btn-success btn-sm" type="submit">
                                <i className="bi bi-floppy me-1"></i>
                                Save
                            </button>
                        </div>
                    </form>
                ) : timeZone ? (
                    <div className="notifications-info-value">{timeZone.timezoneName}</div>
                ) : (
                    <div className="notifications-empty-state py-3">
                        <i className="bi bi-globe"></i>
                        No timezone configured.
                    </div>
                )}
            </div>
        </div>
    );
};

export default TimeZoneCard;
